import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    height: "auto",
  },
  fileInput: {
    width: "97%",
    margin: "10px 0",
  },
  buttonSubmit: {
    marginBottom: 10,
  },
  editor: {
    width: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    paper: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      marginLeft: "-15px",
    },
  },
}));
